<div class="sectionContainer">
  <div *ngIf="items !== null">

    <div *ngIf="serviceTypeId === 1 && items.length >=0">
      <div class="items-scroll-wrapper">
        <table class="subscription-items-table" style="table-layout:fixed; width:100%">
          <!-- ================= NAMED ================= -->
          <ng-container>
            <thead>
              <tr>
                <th style="width:6%">URN</th>
                <th style="text-align:left; width:22%">Name</th>
                <th style="text-align:left">Address</th>
                <th style="text-align:center; width:14%">Region</th>
                <th style="text-align:center; width:6%">IsClient</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items; let i = index">
                <td>{{item.beneficiarySourceURN}}</td>
                <td style="text-align:left;">
                  <span #cell
                        (mouseenter)="showTooltip(i, item.aliases, item.previousNames, cell)"
                        (mouseleave)="hideTooltip(i)"
                        [style.font-weight]="item.isClient ? '900' : 'normal'"
                        style="cursor: pointer; display:inline-block;">
                    {{item.name}}
                  </span>

                  <!-- Hover popup toolbox for alias & previous names (rendered outside table rows) -->
                  <div *ngIf="tooltipVisible[i]" class="hover-card-fixed"
                       [ngStyle]="{ top: tooltipPosition[i]?.top + 'px', left: tooltipPosition[i]?.left + 'px' }"
                       (mouseenter)="onTooltipMouseEnter(i)"
                       (mouseleave)="onTooltipMouseLeave(i)">
                    <div class="tooltip-columns">
                      <!-- Aliases Section -->
                      <div class="tooltip-column">
                        <div class="tooltip-section-header">Aliases</div>
                        <ng-container *ngIf="tooltipContent[i]?.aliases?.length; else noAliases">
                          <div *ngFor="let alias of tooltipContent[i].aliases" class="tooltip-item">{{ alias }}</div>
                        </ng-container>
                        <ng-template #noAliases>
                          <div class="tooltip-item-empty">None</div>
                        </ng-template>
                      </div>

                      <!-- Former Names Section -->
                      <div class="tooltip-column">
                        <div class="tooltip-section-header">Former Names</div>
                        <ng-container *ngIf="tooltipContent[i]?.previousNames?.length; else noFormerNames">
                          <div *ngFor="let formerName of tooltipContent[i].previousNames" class="tooltip-item">{{ formerName }}</div>
                        </ng-container>
                        <ng-template #noFormerNames>
                          <div class="tooltip-item-empty">None</div>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                </td>
                <td style="text-align:left;">{{formatAddress(item)}}</td>
                <td style="text-align:center;">
                  <div class="region-cell">
                    <ng-container *ngIf="getItemRegionCount(item) > 0; else noRegions">
                      <button class="region-count-chip" (click)="openRowRegionPopup(item)" title="Edit regions">
                        {{ getItemRegionCount(item) }} selected
                      </button>
                    </ng-container>
                    <ng-template #noRegions>
                      <button class="region-dots-btn" (click)="openRowRegionPopup(item)" title="Edit regions">&#x22EF;</button>
                    </ng-template>
                  </div>
                </td>
                <td>{{item.isClient === false ? 'No' : 'Yes'}}</td>

              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>

      <div class="addUserButtonContainer">
        <div class="results-count-updated" *ngIf="items.length >=0">
          <p>Found {{items.length}} item(s).</p>
        </div>
        <button mat-raised-button class="addSubscription" (click)="openAddDialog()">
          Edit Subscription Beneficiaries
        </button>
      </div>
    </div>

    <!-- ================= DISCRETIONARY ================= -->
    <ng-container *ngIf="serviceTypeId ===2 && items.length >=0">
      <div class="selected-summary">
        <span class="summary-label">Subscribed Charities Category ({{ getCategoryCount() }})</span>
        <div class="selected-items-preview">
          <ng-container *ngFor="let text of getSubscribedCategoryTextsSorted()">
            <span class="selected-preview-chip selected-chip-green">
              {{ text }}
            </span>
          </ng-container>
        </div>
        <div class="addUserButtonContainer">
          <div class="results-count-updated" *ngIf="items.length >=0">
            <p><!--Found {{getCategoryCount()}} item(s).--></p>
          </div>
          <button mat-raised-button class="addSubscription" (click)="openAddDialog('category')">
            Edit Subscription Categories
          </button>
        </div>

      </div>

      <!-- Selected Regions as green chips -->
      <div class="selected-summary">
        <div class="regions-label-row">
          <span class="summary-label">Subscribed Regions ({{ getRegionCount() }})</span>
          <span class="regions-nb-note">- (N.B. Regions will only be applied to General - Discretionary bequests)</span>
        </div>
        <div class="selected-items-preview">
          <ng-container *ngFor="let name of getSubscribedRegionNamesSorted()">
            <span class="selected-preview-chip selected-chip-green">
              {{ name }}
            </span>
          </ng-container>
        </div>
        <div class="addUserButtonContainer">
          <div class="results-count-updated" *ngIf="items.length >=0">
            <p><!--Found {{getRegionCount()}} item(s).--></p>
          </div>
          <button mat-raised-button class="addSubscription" (click)="openAddDialog('region')">
            Edit Subscription Regions
          </button>
        </div>
      </div>

    </ng-container>


    <!-- ================= TRUST ================= -->
    <ng-container *ngIf="serviceTypeId === 3 && items.length >=0">
      <div class="selected-summary">
        <span class="summary-label">Subscribed Charities Category ({{ getCategoryCount() }})</span>
        <div class="selected-items-preview">
          <ng-container *ngFor="let text of getSubscribedCategoryTextsSorted()">
            <span class="selected-preview-chip selected-chip-green">
              {{ text }}
            </span>
          </ng-container>
        </div>
        <div class="addUserButtonContainer">
          <div class="results-count-updated" *ngIf="items.length >=0">
            <p><!--Found {{getCategoryCount()}} item(s).--></p>
          </div>
          <button mat-raised-button class="addSubscription" (click)="openAddDialog('category')">
            Edit Subscription Categories
          </button>
        </div>

      </div>
    </ng-container>

  </div>

</div>

<!-- Region popup for Named beneficiary rows -->
<div class="row-region-overlay" *ngIf="isRowRegionPopupOpen" (mousedown)="$event.target === $event.currentTarget && closeRowRegionPopup()">
  <div class="row-region-dialog" (mousedown)="$event.stopPropagation()">
    <div class="row-region-header">
      <h3>Region Lookup</h3>
      <button class="row-region-close-btn" (click)="closeRowRegionPopup()" title="Close">&#x2715;</button>
    </div>
    <div class="row-region-content">
      <div class="row-region-search">
        <input type="text" placeholder="Search regions..." [(ngModel)]="rowRegionSearchTerm"
               (ngModelChange)="filterRowRegions()" class="row-region-search-input" />
      </div>
      <div class="row-region-controls">
        <input type="checkbox" (change)="toggleSelectAllRowRegions($event)" />
        <label class="row-region-show-selected">
          <input type="checkbox" [checked]="rowShowSelectedOnly" (change)="rowShowSelectedOnly = !rowShowSelectedOnly; filterRowRegions()" />
          <span>Show selected only</span>
        </label>
      </div>
      <div class="row-region-list">
        <label *ngFor="let region of rowFilteredRegions" class="row-region-item">
          <input type="checkbox" [checked]="isRowRegionSelected(region)" (change)="toggleRowRegion(region)" />
          <span>{{ region.name }}</span>
        </label>
      </div>
    </div>
    <div class="row-region-footer">
      <button class="btn-secondary" (click)="closeRowRegionPopup()">Cancel</button>
      <button class="btn-primary" (click)="saveRowRegions()">Save</button>
    </div>
  </div>
</div>
